const services = [
  {
    group: "Crédito para o seu caixa",
    title: "Antecipação de recebíveis",
    value: "duplicatas, cheques, contratos",
    desc: "Transformamos suas vendas a prazo em vendas à vista.",
    img: "/images/servicos/recebiveis-caderno.jpg",
  },
  {
    group: "Crédito para o seu caixa",
    title: "Fomento à matéria-prima",
    value: "capital de giro",
    desc: "Reforçamos seu capital de giro para a compra de matéria-prima da sua produção.",
    img: "/images/servicos/materia-prima-algodao.jpg",
  },
  {
    group: "Gestão e operação",
    title: "Cobrança simples",
    value: "gestão de carteira",
    desc: "Fazemos a gestão da sua carteira de títulos de forma simples e descomplicada.",
    img: "/images/servicos/cobranca-tablet.jpg",
  },
  {
    group: "Gestão e operação",
    title: "Conta Escrow",
    value: "conta vinculada",
    desc: "Uma conta vinculada recebe e movimenta os recursos da operação, com segurança e transparência para todas as partes.",
    img: "/images/servicos/escrow-fachada.jpg",
  },
  {
    group: "Gestão e operação",
    title: "Operação digital",
    value: "100% online",
    desc: "Os procedimentos da securitização são feitos digitalmente, com agilidade e transparência.",
    img: "/images/servicos/digital-laptop.jpg",
  },
  {
    group: "Gestão e operação",
    title: "Atendimento personalizado",
    value: "contato direto",
    desc: "Acompanhamos sua operação da produção até a chegada do capital em conta.",
    img: "/images/servicos/atendimento-reuniao.jpg",
  },
];

// Desktop: a lista rola e a foto ao lado troca com o serviço do centro da tela (motion.js marca data-active).
// Celular: cada serviço traz a própria foto.
export default function Services() {
  return (
    <section id="servicos" className="sec">
      <div className="wrap">
        <div className="svc-head">
          <h2 className="h2">Nossos serviços</h2>
          <p className="lead" data-reveal>
            Para empresas que vendem a prazo e precisam de caixa para produzir.
          </p>
        </div>

        <div className="svc">
          <ol className="svc-list">
            {services.map((s, i) => (
              <li className="svc-item" key={s.title} data-svc={i} data-active={i === 0 || undefined}>
                <div className="frame svc-thumb" data-clip>
                  <img className="media" src={s.img} alt="" loading="lazy" decoding="async" />
                </div>
                <h3 className="svc-name">{s.title}</h3>
                <p className="svc-value">{s.value}</p>
                <p className="svc-desc">{s.desc}</p>
              </li>
            ))}
          </ol>

          <div className="svc-stage" aria-hidden="true">
            <div className="svc-frame">
              {services.map((s, i) => (
                <img
                  key={s.title}
                  className="media"
                  src={s.img}
                  alt=""
                  data-shot={i}
                  data-active={i === 0 || undefined}
                  loading="lazy"
                  decoding="async"
                />
              ))}
            </div>
            <div className="svc-caption">
              {services.map((s, i) => (
                <span key={s.title} data-shot={i} data-active={i === 0 || undefined}>
                  {s.group}
                </span>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
